import { createStore } from 'vuex';
import DefaultState from './modules/default';
import ApiState from './modules/api';
import AccountState from './modules/account';
import NotificationState from './modules/notification';

export default createStore({
	state: DefaultState.state,
	mutations: DefaultState.mutations,
	actions: DefaultState.actions,
	modules: {
		api: ApiState,
		account: AccountState,
		notification: NotificationState,
	},
});
